/* @flow */

import type { CurrentInfoListItem } from "shop-state/types";

import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslate } from "@awardit/react-use-translate";
import { AnalyticsContext } from "@crossroads/analytics";
import styles from "components/CurrentInfo/CurrentInfoListView/Card/styles.scss";
import cn from "classnames";

type Props = {
  path: string,
  block: CurrentInfoListItem,
};

const Card = ({ path, block }: Props): React$Node => {
  const t = useTranslate();
  const gaContext = useContext(AnalyticsContext);
  const gaRegister = () => {
    gaContext.registerContentClick(`CurrentInfo: ${block.title ?? ""}`, block.id.toString());
  };

  const image = (block.gridImage || block.image);

  return (
    <Link
      className={cn(styles.card, "awardit-currentInfoCardLink")}
      to={{
        pathname: `${path}/${block.id}`,
        state: { hint: { title: block.title } },
      }}
      onClick={gaRegister}
    >
      <div className={styles.shadow} />
      <div className={cn(styles.content, "awardit-currentInfoCardContent")}>
        {block.title &&
          <h2 className={cn(styles.title, "awardit-currentInfoCardTitle")}>{block.title}</h2>
        }
        {image && (
          <div className={cn(styles.image, "awardit-currentInfoCardImage")}>
            <img src={image} alt="" />
          </div>
        )}
        {/* eslint-disable react/no-danger */}
        {block.description &&
          <div
            className={cn(styles.description, "awardit-currentInfoCardDescription")}
            dangerouslySetInnerHTML={{ __html: block.description }}
          />
        }
        {/* eslint-enable react/no-danger */}
        <div className={cn(styles.meta, "awardit-currentInfoCardMeta")}>
          <Link
            className={styles.link}
            to={{
              pathname: `${path}/${block.id}`,
              state: { hint: { title: block.title } },
            }}
            onClick={gaRegister}
          >
            <span className={styles.readMore}>{t("COMMON.READ_MORE")} »</span>
          </Link>
          {block.tags && block.tags.length > 0 &&
            <div className={styles.tags}>
              {block.tags.map((tag, i) => (
                <span key={i} className={styles.tag}>{tag}</span>
              ))}
            </div>
          }
        </div>
      </div>
    </Link>
  );
};

export const DummyCard = (): React$Node => {
  return (
    <div className={styles.card}>
      <div className={styles.content}>
        <div className={cn(styles.title, "awardit-currentInfoCardTitle")} />
        <div className={styles.image} />
        <div className={styles.description} />
      </div>
    </div>
  );
};

export default Card;
